import { getEditor } from './../editors';
import { getRenderer } from './../renderers';
var CELL_TYPE = 'checkbox';
export default {
  editor: getEditor(CELL_TYPE),
  renderer: getRenderer(CELL_TYPE)
};


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/es/cellTypes/checkboxType.js
// module id = 3znm
// module chunks = 0